import config from 'config';

export const INTEGRATIONS = {
  ESIGNATURE: 'eSignature',
  ZAPIER: 'zapier',
  BRIVITY: 'brivity',
};

export const SUBSCRIPTION_STATUSES = {
  TRIALING: 'trialing',
  ACTIVE: 'active',
  PAST_DUE: 'past_due',
  CANCEL_AT_PERIOD_END: 'cancel_at_period_end',
  CANCELED: 'canceled',
};

export const SUBSCRIPTION_PLANS = {
  GROW: {
    PRICE_ID: config.env !== 'production'
      ? 'price_1NzJoTFKujJ5M2zShkoSeKf3'
      : 'price_1NXl3LFKujJ5M2zS65pEYgG0',
    LABEL: 'Grow',
    LIMITS: {
      MEMBERS: 5,
      TRANSACTIONS: 50,
    },
    INTEGRATIONS: [],
    PRICE: 49,
  },
  GROW_SIGN: {
    PRICE_ID: config.env !== 'production'
      ? 'price_1NzJp7FKujJ5M2zSYuUW2waO'
      : 'price_1NzzRMFKujJ5M2zSCMSjQ0f9',
    LABEL: 'Grow + Sign',
    LIMITS: {
      MEMBERS: 5,
      TRANSACTIONS: 50,
    },
    INTEGRATIONS: [INTEGRATIONS.ESIGNATURE],
    PRICE: 149,
  },
  MANAGE: {
    PRICE_ID: config.env !== 'production'
      ? 'price_1NzJpdFKujJ5M2zSR4Xfukh5'
      : 'price_1NXl4MFKujJ5M2zSa692dznX',
    LABEL: 'Manage',
    LIMITS: {
      MEMBERS: null,
      TRANSACTIONS: 200,
    },
    INTEGRATIONS: [],
    PRICE: 199,
  },
  SIGN: {
    PRICE_ID: config.env !== 'production'
      ? 'price_1NzJq1FKujJ5M2zSbm8icCmM'
      : 'price_1NXl5zFKujJ5M2zScsZDz3Qv',
    LABEL: 'Sign',
    LIMITS: {
      MEMBERS: null,
      TRANSACTIONS: 200,
    },
    INTEGRATIONS: [INTEGRATIONS.ESIGNATURE],
    PRICE: 349,
  },
};

export const COMPANY_TYPES = {
  PERSONAL: 'personal',
  CORPORATE: 'corporate',
};

export const COUNTRIES = {
  UNITED_STATES: 'United States',
  CANADA: 'Canada',
};

export const ATTRIBUTION_OPTIONS = {
  SEARCH_ENGINE: 'Search Engine (Google, ChatGPT, etc)',
  REAL_ESTATE_FACEBOOK_GROUP: 'Real Estate Facebook Group',
  FRIEND_COWORKER: 'Friend/Coworker',
  YOUTUBE: 'Youtube',
  INSTAGRAM: 'Instagram',
  OTHER: 'Other',
};
